module.exports = __webpack_public_path__ + "img/title_product.944177ed.png";